import { render } from "./Matters.vue?vue&type=template&id=6ca29955"
import script from "./Matters.vue?vue&type=script&lang=js"
export * from "./Matters.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__